import React from "react";
import { useHistory, useLocation } from "react-router";
import { RowKey } from "src/requests/table/types";

type TabRowOpener = (tableRowKey: RowKey) => void;

export enum TableRowQueryParams {
  ACTIVE_TEMPLATE = "activeItemTemplate",
}

export const useSetActiveItemTable = (): TabRowOpener => {
  const { search, pathname, state } = useLocation();
  const history = useHistory();

  return (tableRowKey: RowKey): void => {
    const query = new URLSearchParams(search);
    query.set(TableRowQueryParams.ACTIVE_TEMPLATE, String(tableRowKey));

    history.replace({ pathname, state, search: query.toString() });
  };
};

export const useActiveItemTable = (): number => {
  const { search } = useLocation();

  const query = new URLSearchParams(search);
  const res = query.get(TableRowQueryParams.ACTIVE_TEMPLATE);

  if (!res) return 0;
  return Number(res);
};
